<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  //接口地址url的统一管理
  import URL from '@/views/trade/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  import { localRead} from '@/utils/tools'
  let enableTypeList = {0:"禁用",1:"启用"};
  export default {
    name: 'productRecord',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created() {
      for (const i in this.enableType) {
        let code = this.enableType[i].value
        let name = this.enableType[i].title
        this.enableObj[code] = name
      }
      this.updateData = {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: "产品名称", field: 'name', required: true },
          { title: "产品编码", field: 'productCode', required: true },
          { title: "产品编码id", field: 'productId', required: true },
          {
            title: "状态",
            field: 'enable',
            type: 2,
            required: true,
            optionList: this.enableObj,
            isNumber: true,
            data: 1
          }
        ]
      },
        this.formData.cols = [
          { title: "产品名称", field: 'name' },
          { title: "产品编码", field: 'productCode' },
          { click: "查询" },
          { click: "重置" },
          { click: "新增" }
        ]
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick(clickName, row) {
        if (clickName == 'update') {
          this.$refs.childUpdate.open(row)
        } else if (clickName == 'delete') {
          this.dataDelete(URL.tradeConfig.product.productDelete, { id: row.id }, res => {
            if (res.code == 0) {
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else if (clickName == 'enableOrNot') {
          row['enable'] = row['enable'] == 0 ? 1 : 0
          this.dataChanage(URL.tradeConfig.product.productUpdate, row, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ('查询' == clickName || window.$t('im.bt.search') == clickName) {
          this.queryData = data
          this.$refs.childTable.defaultGetData(data)
        } else if ('新增' == clickName || window.$t('im.bt.add') == clickName) {
          this.$refs.childUpdate.open()
        } else if ('重置' == clickName || window.$t('im.bt.reset') == clickName) {
          this.formData.cols = [
            { title: "产品名称", field: 'name' },
            { title: "产品编码", field: 'productCode' },
            { click: "查询" },
            { click: "重置" },
            { click: "新增" }
          ]
          this.$refs.childForm.queryListData()
        } else if ('列表显示隐藏' == clickName || window.$t('im.bt.hideOrNo') == clickName) {
          this.pageData.isShow = !this.pageData.isShow
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model) {
        //根据是否包含id更新还是添加
        if (!!model.id) {
          this.dataChanage(URL.tradeConfig.product.productUpdate, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.dataChanage(URL.tradeConfig.product.productAdd, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      dataChanage(url, option, suc, fail) {
        option['operatorName'] = this.userInfo.displayName
        option['operator'] = this.userInfo.id
        option['companyId'] = this.userInfo.companyId
        this.$axios.post(url, option, {
          headers: {
            'isAjax': 'true',
            'Content-Type': 'application/json'
          }
        }).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      dataDelete(url, option, suc, fail) {
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      }
    },
    data() {
      return {
        userInfo: JSON.parse(localRead('trade_sys_userInfo')),  //用户信息
        enableObj: {},
        enableType: [
          { value: 0, title: "禁用" },
          { value: 1, title: "启用" }
        ],
        deleteIds: '',
        queryData: {},
        /*新增或更新*/
        updateData: {},
        /*from查询表单*/
        formData: {
          hasLable: true,
          cols: []
        },
        /*table生成*/
        pageData: {
          isShow: false,
          queryUrl: URL.tradeConfig.product.productQueryList, //请求路径和参数
          selection: false,
          sequence: false,
          method: 'post-json',
          cols: [
            { title: 'ID', field: 'id' },
            { title: "产品名称", field: 'name' },
            { title: "产品编码", field: 'productCode' },
            { title: "产品编码id", field: 'productId' },
            { title: "内部产品编码", field: 'innerCode' },
            { title: "状态", field: 'enable',render:(data,full)=>{
                return enableTypeList[data];
              }},
            { title: "创建时间", field: 'createTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: "修改时间", field: 'updateTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            {
              title: "操作", btnClick: [{
                name: (data, full) => {
                  return full.enable == 0 ? "启用" : "禁用"
                }, size: 'mini', click: 'enableOrNot', type: 'primary', confirm: true
              },
                { name: "修改", size: 'mini', click: 'update', type: 'primary' },
                { name: "删除", size: 'mini', click: 'delete', type: 'primary' }]
            }
          ]
        }
      }
    }
  }
</script>
